// extracted by mini-css-extract-plugin
module.exports = {"CommonCardPageContainer":"CommonCardPage_CommonCardPageContainer__1vVIY","Test":"CommonCardPage_Test__2d8fC","CommonCardPageContent":"CommonCardPage_CommonCardPageContent__3HiNO"};